module.exports = __webpack_public_path__ + "710481b97b990508875f437be177958b.ttf";